import { useMutation, useQueryClient } from 'react-query';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { removeCluster } from 'RestAPIs/admin';

type RemoveRosterClusterVariables = {
  brLinkClusterId: number;
};

const useRemoveCluster = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, RemoveRosterClusterVariables>(
    ({ brLinkClusterId }) => {
      return removeCluster(brLinkClusterId);
    },
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([
          'clusters',
          'list',
          variables.brLinkClusterId
        ]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useRemoveCluster;
